import { AbstractControl } from '@angular/forms';
import { calculateAge, dobRegex } from './util';

export default function atLeast18YearsOld(control: AbstractControl) {
  if (control && control.value) {
    if (dobRegex.test(control.value)) {
      const calcAge = calculateAge(control.value);
      if (calcAge < 18) {
        return {
          atLeast18YearsOld: true,
        };
      }
    }
  }
  return null;
}
